import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaBars, FaMinusCircle } from "react-icons/fa";
import { Tooltip } from "../../tooltip/index";
import { Checkbox } from "../../form/checkbox";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { formatMoneyInputDisplay, parseMoneyInputChange, roundMoneyTwoDecimals, clampMoneyAmount, isValidMoneyInput, } from "../../../utils/money-input-helpers";
const innerRowStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: "8px 10px",
    flex: "1 1 auto",
    minWidth: 0,
};
const DragHandle = SortableHandle(() => {
    return (React.createElement(InputBox, { className: "no-round width40 min40 flex-center cursor-move" },
        React.createElement("p", { className: "big font-bold" },
            React.createElement(FaBars, null))));
});
const SortableItem = SortableElement((props) => {
    const { itemIndex, change, remove, item, getDisplayInput, onMoneyChange, onMoneyBlur } = props;
    return (React.createElement("div", { key: itemIndex, className: "flex-line m-t-2", style: { alignItems: "flex-end", flexWrap: "wrap" } },
        React.createElement("div", { className: "flex-line", style: { width: "104px", minWidth: "104px", alignItems: "flex-end", flexShrink: 0 } },
            React.createElement(DragHandle, null),
            React.createElement(InputBox, { className: "no-round width64 min64 text-center" },
                React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, itemIndex + 1))),
        React.createElement("div", { style: innerRowStyle },
            React.createElement(FormGroup, { className: "m-b-0", no_border: true, style: { width: "180px", minWidth: "160px" } },
                React.createElement(Input, { type: "text", className: "no-round", style: { width: "100%" }, value: item !== undefined && item.name !== undefined ? item.name : "", onChange: (e) => change(itemIndex, "name", e.target.value) })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true, style: { width: "100px", minWidth: "88px" } },
                React.createElement(Input, { type: "text", inputMode: "decimal", className: "no-round", style: { width: "100%" }, value: getDisplayInput(itemIndex, "fee", item.fee === "" ? 0 : Number(item.fee) || 0), onChange: (e) => onMoneyChange(itemIndex, "fee", e.target.value, false), onBlur: (e) => onMoneyBlur(itemIndex, "fee", e.target.value, false) })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true, style: { width: "110px", minWidth: "96px" } },
                React.createElement(Input, { type: "text", inputMode: "decimal", className: "no-round", style: { width: "100%" }, value: getDisplayInput(itemIndex, "min_order", item.min_order || ""), onChange: (e) => onMoneyChange(itemIndex, "min_order", e.target.value, true), onBlur: (e) => onMoneyBlur(itemIndex, "min_order", e.target.value, true) })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true, style: { width: "75px", minWidth: "75px" } },
                React.createElement(InputBox, { className: "no-round flex-center width75" },
                    React.createElement(Checkbox, { id: `${itemIndex}-disabled-fee`, checked: item !== undefined && item.disabled !== undefined ? item.disabled : false, onChange: (e) => change(itemIndex, "disabled", e.target.checked) }))),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true, style: { width: "40px", minWidth: "40px" } },
                React.createElement(Tooltip, { text: "Delete", width: 65, position: "top" },
                    React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(itemIndex) },
                        React.createElement(FaMinusCircle, null)))))));
});
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, itemsLength: props.items.length, change: props.change, remove: props.remove, getDisplayInput: props.getDisplayInput, onMoneyChange: props.onMoneyChange, onMoneyBlur: props.onMoneyBlur })))));
});
export class FieldDeliveryZones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            draftInputs: {},
        };
        autobind(this);
    }
    getDraftKey(i, key) {
        return `${i}:${key}`;
    }
    isValidDecimalInput(raw) {
        return isValidMoneyInput(raw);
    }
    setDraftInput(i, key, value) {
        const draftKey = this.getDraftKey(i, key);
        this.setState((prev) => ({
            draftInputs: {
                ...prev.draftInputs,
                [draftKey]: value,
            },
        }));
    }
    getDisplayInput(i, key, modelValue) {
        const draftKey = this.getDraftKey(i, key);
        const draft = this.state.draftInputs[draftKey];
        if (draft !== undefined)
            return draft;
        return formatMoneyInputDisplay(modelValue);
    }
    onMoneyChange(i, key, raw, optional) {
        if (!this.isValidDecimalInput(raw))
            return;
        this.setDraftInput(i, key, raw);
        if (raw === "") {
            if (optional)
                this.change(i, key, "");
            return;
        }
        if (raw.endsWith("."))
            return;
        const parsed = parseMoneyInputChange(raw);
        if (parsed !== "")
            this.change(i, key, clampMoneyAmount(Number(parsed)));
    }
    onMoneyBlur(i, key, raw, optional) {
        const trimmed = raw.trim();
        if (trimmed === "") {
            if (optional) {
                this.change(i, key, "");
                this.setDraftInput(i, key, "");
                return;
            }
            this.change(i, key, 0);
            this.setDraftInput(i, key, "0.00");
            return;
        }
        const rounded = clampMoneyAmount(roundMoneyTwoDecimals(parseFloat(trimmed) || 0));
        this.change(i, key, rounded);
        this.setDraftInput(i, key, rounded.toFixed(2));
    }
    remove(i) {
        const values = ([...this.props.values]);
        values.splice(i, 1);
        this.setState({ draftInputs: {} });
        this.props.onChange(values);
    }
    change = (i, key, value) => {
        if (key === "fee") {
            value = value === "" || value === undefined ? 0 : Number(value) || 0;
        }
        if (key === "min_order") {
            if (value === "" || value === undefined || value === null)
                value = "";
            else
                value = Number(value) || 0;
        }
        const values = [...this.props.values];
        // Dynamic key assignment: avoid TS narrowing to `never` on indexed write
        values[i][key] = value;
        this.props.onChange(values);
    };
    onSortEnd = ({ oldIndex, newIndex }) => {
        const { onChange, values } = this.props;
        onChange(arrayMove(values, oldIndex, newIndex));
    };
    render() {
        const { values, currencySymbol } = this.props;
        const sym = currencySymbol || "$";
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex-line m-b-2", style: { alignItems: "flex-end", flexWrap: "wrap" } },
                React.createElement("div", { style: { width: "104px", minWidth: "104px" } }),
                React.createElement("div", { className: "flex-line", style: { ...innerRowStyle, marginBottom: 0 } },
                    React.createElement(FormGroup, { style: { width: "180px", minWidth: "160px" }, className: "m-b-0", title: "Zone Name", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "100px", minWidth: "88px" }, className: "m-b-0", title: `Cost (${sym})`, small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "110px", minWidth: "96px" }, className: "m-b-0", title: `Min Order (${sym})`, small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "75px", minWidth: "75px" }, className: "m-b-0", title: "Disabled", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "40px", minWidth: "40px" }, className: "m-b-0", title: "Actions", small_title: true, no_border: true }))),
            React.createElement(SortableItemContainer, { helperClass: "zindex-100 bsl-2", pressDelay: 50, useDragHandle: true, items: values, change: this.change, remove: this.remove, getDisplayInput: this.getDisplayInput, onMoneyChange: this.onMoneyChange, onMoneyBlur: this.onMoneyBlur, onSortEnd: this.onSortEnd })));
    }
}
//# sourceMappingURL=index.js.map